import WeaDialog from "../wea-dialog";
import isFunction from "lodash/isFunction";
import isString from "lodash/isString";
import { loadCss } from "./loadCss";
import WindowFunc from "./window";

export const getDialog = (id = "") => {
  if (window[id]) {
    return window[id];
  }
  if (parent[id]) {
    return parent[id];
  }
};

function getUrlParam(name) {
  let reg = new RegExp("(^|&|\\?)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  let url = self.frameElement ? self.frameElement.getAttribute("src") : "";
  let r = url.match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}

WindowFunc.getTop().getParentDialog = () => {
  let id = getUrlParam("dialogId");
  if (
    id &&
    WindowFunc.getTop().dialogMapper &&
    WindowFunc.getTop().dialogMapper[id]
  ) {
    return WindowFunc.getTop().dialogMapper[id];
  }
};

export const createDialog = (params, children, callback) => {
  let id = `cd${new Date().getTime()}`;
  const node = document.createElement("div");
  node.setAttribute("id", id);
  WindowFunc.getTop().document.body.appendChild(node);
  loadCss();
  return createReactEle(id, WeaDialog, params, children, callback);
};

export const createReactEle = (
  domEle,
  name,
  params = {},
  children,
  callback
) => {
  if (typeof domEle === "string") {
    domEle = WindowFunc.getTop().document.getElementById(domEle);
  }
  let thatCom = null;
  class TheCom extends React.Component {
    render() {
      params.ref = r => (thatCom = r);
      return React.createElement(name, params, children);
    }
  }
  ReactDOM.render(<TheCom />, domEle, function() {
    isFunction(callback) && callback();
  });
  return thatCom;
};

const IconBGCMap = {
  home: {
    //门户
    icon: "icon-coms-home",
    iconBgcolor: "#1a57a0"
  },
  cowork: {
    //协做
    icon: "icon-coms-cowork",
    iconBgcolor: "#a0b0ba"
  },
  workflow: {
    //流程
    icon: "icon-coms-workflow",
    iconBgcolor: "#0079de"
  },
  meeting: {
    //会议
    icon: "icon-coms-meeting",
    iconBgcolor: "#f14a2d"
  },
  blog: {
    //微博
    icon: "icon-coms-blog",
    iconBgcolor: "#6d3cf7"
  },
  crm: {
    //客户
    icon: "icon-coms-crm",
    iconBgcolor: "#96358a"
  },
  photo: {
    //相册
    icon: "icon-coms-photo",
    iconBgcolor: "#0079de"
  },
  hrm: {
    // 人事
    icon: "icon-coms-hrm",
    iconBgcolor: "#217346"
  },
  investigate: {
    //调查
    icon: "icon-coms-investigate",
    iconBgcolor: "#6d3cf7"
  },
  fa: {
    //资产
    icon: "icon-coms-fa",
    iconBgcolor: "#f14a2d"
  },
  doc: {
    //知产
    icon: "icon-coms-doc",
    iconBgcolor: "#f14a2d"
  },
  project: {
    //项目
    icon: "icon-coms-project",
    iconBgcolor: "#217346"
  },
  email: {
    //邮件
    icon: "icon-coms-email",
    iconBgcolor: "#a0b0ba"
  },
  project: {
    //项目
    icon: "icon-coms-project",
    iconBgcolor: "#217346"
  },
  implement: {
    //执行力平台
    icon: "icon-coms-implement",
    iconBgcolor: "#96358a"
  },
  integration: {
    //集成
    icon: "icon-coms-integration",
    iconBgcolor: "#1a57a0"
  },
  official: {
    //公文
    icon: "icon-coms-official",
    iconBgcolor: "#f14a2d"
  },
  schedule: {
    //日程
    icon: "icon-coms-schedule",
    iconBgcolor: "#6d3cf7"
  },
  message: {
    //通信
    icon: "icon-coms-message",
    iconBgcolor: "#0079de"
  },
  car: {
    //车辆
    icon: "icon-coms-car",
    iconBgcolor: "#1a57a0"
  },
  ws: {
    //微搜
    icon: "icon-coms-ws",
    iconBgcolor: "#a0b0ba"
  },
  modelingengine: {
    //表单建模
    icon: "icon-coms-ModelingEngine",
    iconBgcolor: "#96358a"
  },
  mobileengine: {
    //移动建模
    icon: "icon-coms-MobileEngine",
    iconBgcolor: "#96358a"
  },
  finance: {
    //财务
    icon: "icon-coms-Finance",
    iconBgcolor: "#f14a2d"
  },
  content: {
    //通用
    icon: "icon-coms-content",
    iconBgcolor: "#6d3cf7"
  },
  idphoto: {
    //证照
    icon: "icon-coms-ID-Photo",
    iconBgcolor: "#0079de"
  },
  synergism: {
    //协同区
    icon: "icon-coms-synergism",
    iconBgcolor: "#1a57a0"
  },
  collection: {
    //收藏夹
    icon: "icon-coms-Collection",
    iconBgcolor: "#a0b0ba"
  },
  tasks: {
    //计划任务
    icon: "icon-coms-Planning-tasks",
    iconBgcolor: "#96358a"
  },
  emessage: {
    //e-message
    icon: "icon-coms-e-message",
    iconBgcolor: "#0079de"
  },
  littlee: {
    //小e助手
    icon: "icon-coms-little-e",
    iconBgcolor: "#1a57a0"
  },
  lcontract: {
    //合同
    icon: "icon-coms-lcontract",
    iconBgcolor: "#217346"
  },
  currency: {
    //系统设置
    icon: "icon-coms-currency",
    iconBgcolor: "#217346"
  }
};
export const getIconBGC = moduleName => {
  let res = {};
  if (isString(moduleName)) {
    res = IconBGCMap[moduleName] || {};
  }
  return { ...res };
};



// WEBPACK FOOTER //
// ./ecology9/wea-tools/dialog.js